import { Box, Card, CardContent } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'
import { useCallback } from 'react'
import ExcelIcon from 'icons/ExcelIcon'
import PDFIcon from 'icons/PDFIcon'
import ExportedItemOptions from './ExportedItemOptions'

interface Props {
  item: any;
}
export default function ExportedItem({ item }: Props) {
  const globalStyles = useGlobalStyles();

  const renderIcon = useCallback(() => {
    const Icon = item.extension == 'xlsx' ? ExcelIcon : PDFIcon;
    return (
      <Box
        className={globalStyles.sectionButton}
      >
        <Icon size={25} />
      </Box>
    )
  }, []);

  return (
    <Card
      key={item.id}
      sx={{
        borderRadius: 3,
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
      }}
    >
      <CardContent
        sx={{
          p: 2,
          '&:last-child': { pb: 2 },
        }}
      >
        {/* Top row */}
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          {renderIcon()}

          <ExportedItemOptions
            path={item.path}
          />
        </Box>

        {/* User info */}
        <Box mt={1.5}>
          <CustomText
            text={`${item.file_name.replace('Procedures-', '').split('_')[0]}.${item.extension}`}
            color={colors.primary}
            fontSize={15}
            fontWeight={600}
            noWrap
          />

        </Box>
      </CardContent>
    </Card>
  )
}